import Vue from 'vue'
import XRResult  from './result'

export default XRResult




// WEBPACK FOOTER //
// ./src/components/result/index.js